<div class="header-container">
    <span class="fs-20px font-weight-bold text-white">Historial - {{name}}</span>
    <span class="text-white fs-16px" style="cursor: pointer;" (click)="closeDialog()">
        <i class="fa-solid fa-square-xmark"></i>
    </span>
</div>

<mat-dialog-content class="py-1">
	@if(historial.length>0){
		<div class="timeline">
			<div *ngFor="let estatus of historial" class="timeline-item pb-0">
				<div class="timeline-time">
					<span class="date">{{getDate(estatus.fecha)}}</span>
					<span class="time">{{getTime(estatus.fecha)}}</span>
				</div>
				<div class="timeline-icon">
					<a href="javascript:;">&nbsp;</a>
				</div>
				<div class="timeline-content">
					<div class="timeline-header pb-0">
						<div class="username text-center">
							<a href="javascript:;"><b>{{estatus.descripcion}}</b></a>
							<!-- <div class="text-muted fs-12px">8 mins <i class="fa fa-globe-americas opacity-5 ms-1"></i></div> -->
						</div>
					</div>	
					<div class="timeline-body">
						<!-- timeline-post -->
						<div class="d-flex flex-row w-100 align-items-start justify-content-between mb-3">
							<div>
								<div class="userimage"><img class="{{estatus.iconClass}}" alt="" /></div>
							</div>
							<div class="d-flex flex-column mb-2">
								<span class="fs-12px text-transform-uppercase">Usuario: {{estatus.usuario}}</span>
								<!-- <span class="fs-12px text-transform-uppercase">Cliente: {{estatus.cliente}}</span> -->
								<span class="fs-12px text-transform-uppercase">Sucursal: {{estatus.sucursal}}</span>
							</div>
						</div>
					</div>
                </div>
			</div>
		</div>
	}@else{
		<p class="text-center w-100 py-5">No se encontraron registros históricos del Plan Protection</p>
	}
	<br>
</mat-dialog-content>

